import { initSection } from '../../core/shopify/init-section/index.js';
import Swiper, { Grid, Navigation, Pagination, Thumbs } from 'swiper';
Swiper.use([
    Grid,
    Navigation,
    Pagination,
    Thumbs
]);
const NAMESPACE = '.js-gift-set-gallery-section';
initSection(NAMESPACE, (section)=>{
    const mainElement = section.querySelector('.js-gift-set-gallery-main');
    const thumbsElement = section.querySelector('.js-gift-set-gallery-thumbs');
    const paginationElement = section.querySelector('.js-gift-set-gallery-pagination');
    const previousElement = section.querySelector('.js-gift-set-gallery-prev');
    const nextElement = section.querySelector('.js-gift-set-gallery-next');
    if (!mainElement || !thumbsElement) return {
        unload: null
    };
    const thumbs = new Swiper(thumbsElement, {
        direction: 'horizontal',
        freeMode: true,
        slidesPerView: 4,
        spaceBetween: 12,
        watchSlidesProgress: true,
        breakpoints: {
            0: {
                direction: 'horizontal',
                slidesPerView: 4,
                spaceBetween: 4
            },
            1024: {
                direction: 'horizontal',
                slidesPerView: 6,
                spaceBetween: 10,
                grid: {
                    rows: 2,
                    fill: 'row'
                }
            },
            1600: {
                direction: 'horizontal',
                slidesPerView: 6,
                spaceBetween: 20,
                grid: {
                    rows: 2,
                    fill: 'row'
                }
            }
        }
    });
    const main = new Swiper(mainElement, {
        spaceBetween: 0,
        thumbs: {
            swiper: thumbs
        },
        pagination: {
            el: paginationElement,
            clickable: true
        },
        navigation: {
            prevEl: previousElement,
            nextEl: nextElement
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            1200: {
                slidesPerView: 1.3,
                spaceBetween: 10
            },
            1440: {
                slidesPerView: 1.45,
                spaceBetween: 10
            }
        }
    });
    const onThumbClick = (event)=>{
        if (!(event.target instanceof Element)) return;
        const thumb = event.target.closest('.GiftSetGallery-thumb');
        if (!thumb || !thumbsElement.contains(thumb)) return;
        const slideIndex = Array.from(thumbsElement.querySelectorAll('.GiftSetGallery-thumb')).indexOf(thumb);
        if (slideIndex !== -1 && slideIndex !== main.activeIndex) {
            main.slideTo(slideIndex);
        }
    };
    thumbsElement.addEventListener('click', onThumbClick, true);
    return {
        unload: ()=>{
            thumbsElement.removeEventListener('click', onThumbClick, true);
            main.destroy(true, true);
            thumbs.destroy(true, true);
        }
    };
});
